import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import * as Actions from '@/app/store/actions';
import { generateAgeString } from '@/utils/utils';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, CircularProgress, IconButton } from '@material-ui/core';
import { ArrowForwardIos } from '@material-ui/icons';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const StudentView = ({ student, isLoading, setCurrentState, isAdmin, token }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const goToEditStudent = () => {
		if (isAdmin) {
			navigate({
				pathname: `/students-editstudent/${student.id}`,
				state: { student, tab: 'personal' },
			});
		} else {
			navigate('/studentformedit', { student, tab: 'personal', token });
		}
	};
	const handleNext = () => {
		if (
			student?.first_name &&
			student?.last_name &&
			student?.date_of_birth &&
			student?.gender &&
			student?.address1 &&
			student?.country_id &&
			student?.state_id &&
			student?.city &&
			student?.zip_code
		) {
			setCurrentState('medication');
		} else {
			dispatch(
				Actions.showMessage({
					message: 'Please fill the personal information',
					autoHideDuration: 3000,
					variant: 'error',
				})
			);
		}
	};
	return (
		<>
			<div className="flex items-center justify-between">
				<div>
					{isAdmin ? (
						<span className="sm:mr-12 icon-color">
							<IconButton
								onClick={() => {
									navigate('/students');
								}}
							>
								<img alt="filter" className="fiterimg" src="assets/images/arrow-long.png" width="24px" />
							</IconButton>
						</span>
					) : null}
					<span className="md:text-pd-lg lg:text-pd-xl self-end font-extrabold">Personal Information</span>
				</div>
				<div className="flex justify-between">
					<span className="mx-4">
						<CustomButton
							disabled={isLoading}
							fontSize="15px"
							height="46"
							onClick={goToEditStudent}
							variant="secondary"
							width="100px"
						>
							<FontAwesomeIcon icon={faEdit} />
							<span> Edit </span>
						</CustomButton>
					</span>
				</div>
			</div>
			<div className="bg-white rounded-lg p-32 py-44 mx-auto mt-20 sm:pr-32">
				<div className="flex flex-wrap sm:flex-nowrap justify-center">
					<div className="mx-64 shrink-0">
						<Avatar src={student?.photo} style={{ height: '140px', width: '140px' }} />
					</div>
					{isLoading ? (
						<div className="flex items-center justify-center flex-grow">
							<CircularProgress size={35} />
						</div>
					) : (
						<div className="grid grid-cols-2 sm:grid-cols-3 md:flex-grow mx-auto mt-32 sm:mt-0" style={{ gap: '30px' }}>
							<div className="">
								<div style={{ fontSize: 14 }}>Name</div>
								<div className="font-bold turncate break-word capitalize" style={{ fontSize: 16 }}>
									{student?.first_name} {student?.last_name}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Birthday</div>
								<div className="font-bold turncate break-word" style={{ fontSize: 16 }}>
									{student?.date_of_birth ? dayjs(student?.date_of_birth).format('MMM DD, YYYY') : '-'}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Age</div>
								<div className="font-bold turncate break-word" style={{ fontSize: 16 }}>
									{generateAgeString(student?.date_of_birth)}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Gender</div>
								<div className="font-bold turncate break-word capitalize" style={{ fontSize: 16 }}>
									{student?.gender || '-'}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Address</div>
								<div className="font-bold turncate break-word" style={{ fontSize: 16 }}>
									{student?.address1 || `${student?.first_name} ${student?.last_name} has no address on record`}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Country</div>
								<div className="font-bold turncate break-word capitalize" style={{ fontSize: 16 }}>
									{student?.country?.name || '-'}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>State</div>
								<div className="font-bold turncate break-word capitalize" style={{ fontSize: 16 }}>
									{student?.state?.name || '-'}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>City</div>
								<div className="font-bold turncate break-word capitalize" style={{ fontSize: 16 }}>
									{student?.city?.name || '-'}
								</div>
							</div>
							<div className="">
								<div style={{ fontSize: 14 }}>Zipcode</div>
								<div className="font-bold turncate break-word capitalize" style={{ fontSize: 16 }}>
									{student?.zip_code || '-'}
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
			<div className="w-full flex justify-end mt-20 mb-80 pb-80 lg:mb-64 lg:pb-64">
				<CustomButton
					disabled={isLoading}
					fontSize="15px"
					height="46"
					onClick={handleNext}
					variant="primary"
					width="100px"
				>
					<div className="flex items-center justify-center ml-6">
						Next
						<ArrowForwardIos className="ml-6" style={{ fontSize: '1.6rem' }} />
					</div>
				</CustomButton>
			</div>
		</>
	);
};

export default StudentView;
